import * as Farmapremium from './farmapremium'
import * as Nextera from './nextera'
import * as Farmapolis from './farmapolis'
import * as FarmapremiumClientes from './farmapremium-clientes'
import * as Farmacloud from './farmacloud'

let dashboard
const envDashboard = process.env.VUE_APP_DASHBOARD
switch (envDashboard) {
  case 'farmapremium':
    dashboard = Farmapremium
    break
  case 'nexterafarma':
    dashboard = Nextera
    break
  case 'farmapolis':
    dashboard = Farmapolis
    break
  case 'farmapremium-clientes':
    dashboard = FarmapremiumClientes
    break
  case 'farmacloud':
    dashboard = Farmacloud
    break
  default:
    dashboard = Farmapremium
}

const {
  Auth,
  routerGuard,
  frontendcommonCss,
  colors,
  logo,
  logoSmall,
  logoColor,
  logoColorSmall,
  shellConfigUrl,
  enableMobileLayout,
  sidebarLoading,
  SidebarBottom,
  App,
  URLS,
  AxiosPlugin,
  sentryDns,
  LoadingSpinner
} = dashboard

export {
  Auth,
  routerGuard,
  frontendcommonCss,
  colors,
  logo,
  logoSmall,
  logoColor,
  logoColorSmall,
  shellConfigUrl,
  enableMobileLayout,
  sidebarLoading,
  SidebarBottom,
  App,
  URLS,
  AxiosPlugin,
  sentryDns,
  LoadingSpinner,
  envDashboard
}
